import * as logClient from "@classdojo/log-client";
import { type ProductEvent } from "@classdojo/log-client/lib/client/client";
import { setUser } from "@web-monorepo/telemetry";
import { useEffect } from "react";
import { useToolkitSession } from "src/pods/auth/useToolkitSession";

type ToolkitLogEvent = string | ProductEvent;

let pendingEvents: ToolkitLogEvent[] = [];
let isConfigured = false;
let configuredUserId: string | undefined;

function normalizeEvent(event: ToolkitLogEvent): ProductEvent {
  return typeof event === "string" ? { eventName: event } : event;
}

export async function logToolkitEvent(event: ToolkitLogEvent) {
  if (!isConfigured) {
    pendingEvents.push(event);
    return;
  }

  await logClient.logEvent(normalizeEvent(event));
}

export async function configureToolkitLogger({ userId }: { userId?: string }) {
  if (userId && configuredUserId !== userId) {
    configuredUserId = userId;
    setUser({ id: userId });
    await logClient.setEntityId(userId);
  }

  isConfigured = true;

  const queuedEvents = [...pendingEvents];
  pendingEvents = [];

  for (const event of queuedEvents) {
    await logClient.logEvent(normalizeEvent(event));
  }
}

export function resetToolkitLoggerForTest() {
  pendingEvents = [];
  isConfigured = false;
  configuredUserId = undefined;
}

export function useToolkitLogger() {
  const { isLoading, user } = useToolkitSession();

  useEffect(() => {
    if (isLoading) return;

    void configureToolkitLogger({ userId: user?._id });
  }, [isLoading, user?._id]);

  return { logToolkitEvent };
}
